import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-check-domain',
  templateUrl: './check-domain.component.html',
  styleUrls: ['./check-domain.component.css'],
  standalone: true,
  imports: [CommonModule, TranslateModule, FooterComponent]
})
export class CheckDomainComponent implements OnInit {

  currentUser: any = '';
  LogoUrl: any = '';
  companyName: any = '';
  companyOwnWebsite: any = '';
  currentUrl: string = '';
  lanName: any = '';

  constructor(
    private router: Router,
    private titleService: Title,
    private apiService: ApiService,
    public translateService: TranslateService
  ) {
    this.lanName = localStorage.getItem('net_lang_new');
    if (this.lanName == null) {
      this.lanName = 'jp';
    } else {
      this.lanName = localStorage.getItem('net_lang_new');
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle('Domain Check - Transfer Center');
    // Initialize with default values to prevent undefined errors
    this.currentUser = {
      background_type: '0',
      background_color: '#f8f9fa',
      button_background_color: '#2196f3',
      button_text_color: '#ffffff',
      organization_name: 'Transfer Center'
    };
    this.LogoUrl = '';
    this.companyName = 'Transfer Center';
    this.companyOwnWebsite = 'https://transfercenter.jp';
    
    // Optional: Try to get freelancer details but don't redirect on failure
    this.getFreelancerBrandDetails('');
    this.checkDomainStatus();
  }

  checkDomainStatus(){
    // Use window.location instead of deprecated router API
    this.currentUrl = window.location.origin;
    var pathArray = this.currentUrl.split('.');
    var host = pathArray[0].split('//');
    var url = window.location.host; // Use actual host instead of hardcoded

    let jSon = {
      domain : url,
      certificate_status : 3
    }
    this.apiService.certificateStatusChange(jSon).subscribe((res: any) => {
      if (res.success == 1) {

      }
    }, (err: any) => {
      console.log('Using default branding settings');
    });
  }


  getFreelancerBrandDetails(freelancerId: any) {
    // Use window.location instead of deprecated router API
    this.currentUrl = window.location.origin;
    var pathArray = this.currentUrl.split('.');
    var host = pathArray[0].split('//');
    var url = window.location.host; // Use actual host instead of hardcoded
    
    let jSon = {
      // brand_url: 'whitepoint.net0.download',
      brand_url: url,
      uid: freelancerId,
    }

    this.apiService.getFreelancerDetails(jSon).subscribe((res: any) => {
      if (res.success == 1) {
        this.currentUser = res.data;
        this.LogoUrl = this.currentUser.logo_url;
        this.companyName = this.currentUser.company_name;
        this.companyOwnWebsite = this.currentUser.company_website_hyperlink == null ? "https://transfercenter.jp" : this.currentUser.company_website_hyperlink;

        if (this.currentUser.organization_name != '' && this.currentUser.organization_name != 'null' && this.currentUser.organization_name != null) {
          this.titleService.setTitle(this.currentUser.organization_name + ' - Domain Check');
        }
      }
      // Don't redirect on failure - just use default values
    }, (err: any) => {
      console.log('Using default branding settings');
    });
  }

}
